import { Component, OnInit, OnDestroy, ElementRef, HostListener, LOCALE_ID, Inject,ChangeDetectorRef } from "@angular/core";
import { Router, NavigationExtras } from "@angular/router";
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { appConstants } from 'src/app/shared/constants/app.constants';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { CarouselConfig } from 'ngx-bootstrap/carousel';

import { ApiService } from "src/app/config/api.service";
import { Category, Merchant, Offer, OffersApiResponse } from "src/app/shared/interfaces/offers.interface";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { OverrideStyleConfig } from "@pv-frontend/pv-shared-components/common/types";
import { AdobeAnalyticsService } from "src/app/shared/services/common/adobeAnalytics.service";

@Component({
  selector: "app-homepage",
  templateUrl: "./homepage.component.html",
  styleUrls: ["./homepage.component.scss"],
  providers: [
    { provide: CarouselConfig, useValue: { interval: 6000, noPause: true, showIndicators: true } }
  ]
})

export class HomepageComponent implements OnInit,OnDestroy {
  
  brandTickers: {
    logo: string;
    style: OverrideStyleConfig;
    merchantId: string;
    name: string;
  }[] = [
    {
      logo: "https://images.poshvine.com/icon/zoho-logo-darkbg.svg",
      name: "Zoho",
      style: {
        mobile: { height: "65%" },
        desktop: { height: "65%" },
      },
      merchantId: "9835d0d7-d5af-432e-8f2e-87ba1dd16723",
    },
    {
      logo: "https://images.poshvine.com/icon/Google-Ads-full-white.png",
      name: "Google Ads",
      style: {
        mobile: { height: "50%" },
        desktop: { height: "50%" },
      },
      merchantId: "aab6683b-4bcb-4e20-841e-41fc0f377ad2",
    },
    {
      logo: "https://assets.poshvine.com/merchants/mastercard/easy-savings-special/images/hubspot-logo-dark.webp",
      name: "HubSpot",
      style: {
        mobile: { height: "50%" },
        desktop: { height: "50%" },
      },
      merchantId: "857b8593-f0a7-485e-82ae-fe52030720ea",
    },
    {
      logo: "https://images.poshvine.com/icon/Shopify+partners.png",
      name: "Shopify",
      style: {
        mobile: { height: "100%", paddingRight: "0px", paddingLeft: "0px" },
        desktop: { height: "100%", paddingRight: "0px", paddingLeft: "0px" },
      },
      merchantId: "c71eb4fb-de6f-4b6a-adeb-875feea6bd66",
    },
    {
      logo: "https://images.poshvine.com/icon/Xero_software_logo.svg",
      name: "Xero",
      style: {
        mobile: {},
        desktop: {},
      },
      merchantId: "27889623-76c4-48c9-88c3-9091dcb78606",
    },
    {
      logo: "https://images.poshvine.com/icon/Google_Workspace.svg",
      name: "Google Workspace",
      style: {
        mobile: { height: "37%" },
        desktop: { height: "37%" },
      },
      merchantId: "17fc8d71-b9c9-4052-92cd-fc0d8453e9cc",
    },
    {
      logo: "https://images.poshvine.com/icon/Consulting-Logo-White.svg",
      name: "Consulting IQ",
      style: {
        mobile: { height: "50%" },
        desktop: { height: "50%" },
      },
      merchantId: "ace4a498-c707-43b3-ad40-25e6634f30bb",
    },
  ];

  categories;

  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktopDevice: boolean = false;
  isCategoryLoading = true;
  public bannerLoading = true;
  appConstants = appConstants;
  categorySubscription: Subscription;
  bannerItems: Array<any> = [];
  filteredBanners: Array<any> = [];
  shouldCallAPI: boolean = false;
  selectedCategory?: Category;
  private destroy$: Subject<void> = new Subject<void>();
  public isLoadingOffers: boolean = false;
  public offers: Offer[];
  public merchants: Merchant[];
  public tabIndex: number = 0;
  public languagesToReduceFontSize: string[] = ['fr-ca', 'uk', 'ka', 'th', 'vi', 'ru', 'uz', 'my', 'es', 'kk', 'fr', 'id', 'az'];
  public isReduceFontSize: boolean = false;

  @HostListener('unloaded')
  ngOnDestroy() {
    // this.dataTransferService.nextMessage(null)
    if(this.categorySubscription){
      this.categorySubscription.unsubscribe()
    }
    this.elementRef.nativeElement.remove();
    this.destroy$.next();
    this.destroy$.complete();
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth > 1024) {
      this.isDesktopDevice = true;
      this.isTablet = false;
      this.isMobile = false;
      this.filterBanners();
    }
    else if (window.innerWidth > 992) {
      this.isDesktopDevice = false;
      this.isTablet = true;
      this.isMobile = false;
      this.filterBanners();
    }
    else {
      this.isDesktopDevice = false;
      this.isTablet = false;
      this.isMobile = true;
      this.filterBanners();
    }
  }

  constructor(
    public router: Router,
    public _authService: AuthService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private title: Title,
    private dataTransferService: DataTransferService,
    private elementRef: ElementRef,
    public _apiService: ApiService,
    @Inject(LOCALE_ID) public locale: string,
    private cdr: ChangeDetectorRef,
    public adobeAnalyticsService: AdobeAnalyticsService,
  ) {
    this.commonService.countryEvent.subscribe((res: boolean) => {
      if (res && this.shouldCallAPI) {
        this.getBannerItems({});
      }
    })
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.onResize()
    this.title.setTitle(appConstants.baseTitle);
    const data = {
      pageName: 'Home page',
    }    
    this.dataTransferService.nextMerchantOfferData(data);
    this.getCategories();
    this.getOffersByCategory();
    if (localStorage.getItem("userCountry") && sessionStorage.getItem("userLanguage")) {
      this.getBannerItems({});
    } else {
      this.shouldCallAPI = true;
    }
    this.duplicateBrandTickers();
    this.shouldReduceFontSize();
    
    this.adobeAnalyticsService.loadDataLayerScript({
      siteSection1: "Home Page",
      siteSection2: "Home Page",
      pageName: "Home Page", 
      contentType: "Home Page - Offer listing",
    });
    this.commonService.sendAnalyticsData('pageLoad' , 'pageInfo' , window['di']) ;
  }

  private duplicateBrandTickers() {
    this.brandTickers = [...this.brandTickers, ...this.brandTickers, ...this.brandTickers];
  }

  shouldReduceFontSize(): void {
     this.isReduceFontSize = this.languagesToReduceFontSize.includes(this.locale);
  }

  getCategories() {
    if(!this.categorySubscription){
      this.categorySubscription = this.dataTransferService.sharedCategories.subscribe(res => {
        if (res && res.data) {
          this.categories = res.data;
          this.categories[0] && this.handleCategorySelection(this.categories[0]);
          this.isCategoryLoading = false;
        } else if(res && res.isLoading){
          this.isCategoryLoading = true;
        }
      });
    }
  }

  private getOffersByCategory(): void {
    this.isLoadingOffers = true;
    this.offers = [];
    this.merchants = [];
    const params = {
      per_page: 8
    };
    if (this.selectedCategory) params['categories'] = this.selectedCategory?.attributes.code;
    this._apiService.getOffers(params)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.isLoadingOffers = false)
    )
    .subscribe({
      next: (response: OffersApiResponse) => {
        this.merchants = response?.included?.filter((info) => info.type === 'merchant');
        this.offers = response?.data?.map((offer: Offer) => {
          return {
            ...offer,
            merchant: this.getMerchantDetails(offer),
            isDisabled: this._authService.isAuthenticated() ? !offer?.attributes?.claimable : false
          }
        });     
      },
      error: () => {
        // Error handling done in services.
        }
    })
  }

  getBannerItems(params) {
    if(localStorage.getItem("userCountry") && sessionStorage.getItem("userLanguage")) {
      this._apiService.getBanners(params).subscribe((res: any) => {
        this.bannerItems = res?.data ?? [];
        this.filterBanners();
      });
    }
  }

  filterBanners() {
    this.filteredBanners = [];
    const isUserLoggedIn = this._authService.isAuthenticated();
    this.bannerItems.forEach((banner) => {
       let bannerCode = banner.attributes.code;
       if ((!isUserLoggedIn && bannerCode.includes('pre-login')) && (bannerCode.includes('mobile') && this.isMobile)) {
        return this.filteredBanners.push(banner);
       } else if((isUserLoggedIn && bannerCode.includes('post-login')) && (bannerCode.includes('mobile') && this.isMobile)) {
        return this.filteredBanners.push(banner);
       } else if((!isUserLoggedIn && bannerCode.includes('pre-login')) && (bannerCode.includes('desktop') && !this.isMobile)) {
        return this.filteredBanners.push(banner);
       } else if((isUserLoggedIn && bannerCode.includes('post-login')) && (bannerCode.includes('desktop') && !this.isMobile)) {
        return this.filteredBanners.push(banner);
       }
      }
    );
    this.bannerLoading = false
    this.cdr.detectChanges();
  }

  public isArray(value) {
    return Array.isArray(value);
  }

  public analyticsLinkData(type: string) {
    this.commonService.sendAnalyticsData('home_click',
    
    'clickInfo' ,
    {
      siteSection : "footer",
      clickPosition : "footer_banner",
      pageURL:"https://www.priceless.com/easy-savings?ac=easysavings", 
      button_name : type,
      linkType : "navigation"
    } )
  }

  private getMerchantDetails(offer) {
    return this.merchants.find((merchant) => merchant.id === offer.relationships.merchant.data.id);
  }

  public handleCategorySelection(category?: Category): void {
    this.selectedCategory = category;
    this.analyticsCategoryClickData();
    this.getOffersByCategory();
  }

  private analyticsCategoryClickData() {  
  //  this.commonService.sendAnalyticsData('offer_category_click', { 
  //   siteSection : "content_body",
  //   clickPosition : "all_offers", // ticker or footer_banner  
  //   button_name : "offer_category",
  //   linkType : "interaction" 
  // })
  }

  public redirectToListingPage(): void {
    this.router.navigate([`/offers/list/${this.selectedCategory.attributes.parent_code}/${this.selectedCategory.attributes.code}`]);
  }

  public handeTabIndexChange(index: number) {
    this.tabIndex = index;
  }

  public redirectToDetails(merchantId: string, merchantName: string): void {
    let url = `/offers/details/${merchantId}/all/${merchantName.toLowerCase().replace(/\s+/g, '-')}`
    this.analyticsBannerClickData(url , merchantName);
    this.router.navigate([url]);
  }

  private analyticsBannerClickData(url: string , merchantName: string) {
   this.commonService.sendAnalyticsData('home_click', 'clickInfo' , { 
    siteSection : "content_body",
    clickPosition : "ticker",
    pageURL:url, 
    button_name : merchantName,
    linkType : "navigation" 
  })
  }
}
